import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FileAttachment } from '../../models/file-attachment.model';

@Component({
  selector: 'ara-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.css']
})
export class RemarksComponent implements OnInit, OnChanges {
  remark: Remark = new Remark();
  showRemarks: boolean = false;
  @Input()
  disabled: boolean = false;
  @Input()
  RemarkText: string;
  @Input()
  RemarkFiles: FileAttachment[] = [];
  PreviewFiles: FileAttachment[] = [];
  showRemarkError: boolean = false;
  @Output()
  finalRemark: EventEmitter<Remark>;
  accept: string;
  constructor() {
    this.finalRemark = new EventEmitter<Remark>();
    this.accept = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS';
  }

  ngOnInit() {
    this.remark.RemarkText = this.RemarkText;
  }
  ngOnChanges() {
    this.remark.RemarkText = this.RemarkText;
  }
  getRemarks(remark, type) {
    switch (type) {
      case 'RemarkText':
        this.remark.RemarkText = remark;
        break;
      default:
        break;
    }
  }
  showRemarksDialog(event) {
    if (!this.disabled) {
      this.showRemarks = true;
      this.ngOnInit();
    }
  }
  checkRemarkValidation() {
    if (!this.remark.RemarkText) {
      this.showRemarkError = true;
      return;
    }
    this.finalRemark.emit(this.remark);
    this.remark = new Remark();
    this.showRemarks = false;
  }
  onInputFilesUpdated(files) {
    this.remark.RemarkFiles = files;
  }
  onCancelClick() {
    this.remark = new Remark();
    this.showRemarks = false;
  }
}
export class Remark {
  RemarkText: string;
  RemarkFiles: FileAttachment[] = [];
}
